/**
 * Export Schema of PanelUser
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'
import {Address} from '@/model/resource/Address'

/* TODO: review generated schema */
export class ExportPanelUserSchema extends Schema {
  readonly name = 'ExportPanelUser'

  readonly fieldSet: FieldSet<PanelUser> = {
    idPanelUserPk: schema => schema.model.idPanelUserPk,
    document: schema => schema.model.document,
    corporateName: schema => schema.model.corporateName,
    contactName: schema => schema.model.contactName,
    telephone: schema => Helper.phone(schema.model.telephone),
    email: schema => schema.model.email,
    address: schema =>
      schema.model.address && Address.stringfied(schema.model.address),
    dueDate: schema => Helper.datetime(schema.model.dueDate),
    active: schema => Helper.bool(schema.model.active),
    integrationEnabled: schema =>
      Helper.bool(schema.model.panelUserFlags?.integrationEnabled),
    tms: schema => schema.model.panelUserInfo?.tmsIntegration || '',
    panelUserType: schema => schema.model.panelUserInfo?.tipoCliente.nome || '',
    partnerName: schema => schema.model.panelUserInfo?.partnerName || '',
    unlimitedTransporterAccess: schema =>
      Helper.bool(schema.model.panelUserFlags?.unlimitedTransporterAccess),
    hasControlTower: schema =>
      Helper.bool(schema.model.panelUserFlags?.hasControlTower),
    towerControlManagerName: schema =>
      schema.model.panelUserInfo?.towerControlManagerName || '',
    lastUpdate: schema => Helper.date(schema.model.lastUpdate) || '',
    registrantId: schema =>
      schema.model.panelUserInfo &&
      schema.model.panelUserInfo?.idAdministradorFk,
    registrantName: schema =>
      (schema.model.panelUserInfo &&
        schema.model.panelUserInfo?.administrator?.email) ||
      '',
    createdByAdm: schema => schema.model.createdBy,
    idUserTypeFk: schema =>
      schema.model.userType && schema.model.userType?.$tag,
    creationDate: schema => Helper.date(schema.model.creationDate),
  }
}
